import './vendor/jssocials';

let $shareLinks =$(".js-share-link");

$shareLinks.jsSocials({
	showLabel: false,
    showCount: false,
    shares: ["telegram", "whatsapp", "vkontakte"]
});


$('.share-link').on('click', function(){
	$shareLinks.fadeToggle();
})